const projectDetailFragment = /* GraphQL */ `
  fragment ProjectDetailFragment on Project {
    year
    make
    makeId
    model
    modelId
    raceName
    raceTypeId
    raceImageUrl
    shopUrl
    searchUrl
    projectId
    customerProjectUrl
    customerProjectShopUrl
    customerProjectSearchUrl
    clearSelectionUrl
    marketId
    superMarketId
    vehicleBaseId
    engineManufacturer
    engineManufacturerId
    engineMake
    engineMakeId
    engineSeries
    engineSeriesId
    engineConfiguration
    engineConfigurationId
    engineVersion
    engineVersionId
    engineQualifier
    engineQualifierId
    engineDisplacement
    engineDisplacementId
    engineCode
    engineCodeId
    engineCamshaftType
    engineCamshaftTypeId
    engineFuelSystem
    engineFuelSystemId
    engineDisplayName
    isStockEngine
  }
`

export default projectDetailFragment
